<template>
  <el-dialog :title="$t('ExcelConfig.Title')" :visible.sync="dialogVisible" width="600px" :before-close="hide" destroy-on-close append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-position="left">
      <el-form-item :label="$t('fileSearch.table.FileType')" prop="fileType">
        <BjSelectLov v-model="form.fileType" :option-list="fileTypeList" :placeholder="$t('fileSearch.table.FileType')"/>
      </el-form-item>
      <el-form-item :label="$t('table.remarkText')" prop="remarks">
        <BjInput v-model="form.remarks" type="textarea" show-word-limit :maxlength="MAX_LENGTH.BILLMAX" autosize :placeholder="$t('inputText')" clearable />
      </el-form-item>
      <el-form-item :label="$t('ExcelConfig.Title')">
        <UploadFile ref="UploadFileRef" class="avatar-uploader" :limit="1" :limit-size="5 * 1024" multiple show-file-list accept="image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx" :accept-list="['image/jpeg', 'image/png', '.csv', '.pdf', '.doc', '.xlsx']" auto-upload limit-hide @handleFileListChange="fileListChange">
          <template slot="default">
            <el-button size="small" type="primary">{{ $t('BusinessImportHistory.page.SelectFile') }}</el-button>
          </template>
        </UploadFile> 
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import UploadFile from '@/views/center-business/third/csg/order/components/UploadFile';
  import { userApi } from '@/api';

  export default {
    components: { UploadFile },
    data() {
      return {
        dialogVisible: false,
        fileList: [],
        form: {
          fileType: '',
          remarks: '',
        },
        fileTypeList: [
          {label:'Contract',value:'Contract'},
          {label:'Rate Card',value:'Rate Card'},
          {label:'Terms and Conditions',value:'Terms and Conditions'},
          {label:'Credit Application',value:'Credit Application'},
          {label:'Inbound Checklist',value:'Inbound Checklist'},
          {label:'Internal Handover Form',value:'Internal Handover Form'},
          {label:'IT Checklist',value:'IT Checklist'},
          {label:'Others',value:'Others'},
        ],
        rules: {
          fileType: [{ required: true, message: this.$t('inputText'), trigger: 'change' }],
        },
      };
    },
    methods: {
      show() {
        this.file = null;
        this.form.fileType = null;
        this.form.remarks = null;
        this.fileList = [];
        this.dialogVisible = true;
      },
      hide() {
        this.dialogVisible = false;
      },
      fileListChange(file) {
        const totalSize = file.reduce((total, item) => total + item.size, 0)
        if(totalSize > 1024 * 1024 * 30) return this.$message.warning(this.$t('ExcelConfig.maximum2'));

        this.fileList = file.map(item => { return { name : item.name, url: item.url}});
        this.form.annex = JSON.stringify(this.fileList)
      },
      handleConfirm() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.fileList.length==0) return this.$message.warning(this.$t('ExcelConfig.upload'))
            let POSTDATA = {
              cusId: this.$route.query.cusId || null,
              fileName: this.fileList[0].name,
              filePath: 'https://'+this.fileList[0].url,
              fileType: this.form.fileType,
              remarks: this.form.remarks,
              parentId: this.$route.query.parentId,
            }
            // 新增接口
            userApi.addUserfileDetailsList(POSTDATA).then(res => {
              if (!res.failed) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                    this.hide();
                    this.$emit('reFresh');
                }, 500);
              }
            });
          }
        })
      },
    },
  };
  </script>
  <style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
